import { useMemo } from 'react';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import useDashboardSelector from '../../../../redux/selectorHooks/useDashboardSelector';
import { assertNotNil } from '../../../../utils/types';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { selectModalData } from '../../../../redux/selectors/modal';
import {
  closeModal,
  IDashboardDeleteReportData,
} from '../../../../redux/slices/modal';
import useDashboardDeleteContent from '../../utils/useDashboardDeleteContent';
import { analysisSelector } from '../../../../redux/selectors/analyses';

const DashboardDeleteReportModal = () => {
  const dispatch = useAppDispatch();
  const dashboard = useDashboardSelector('dashboard');
  assertNotNil(dashboard);

  const modalData = useAppSelector(
    selectModalData,
  ) as IDashboardDeleteReportData;
  const { analysisId, position } = modalData;

  const analysisMemoizedSelector = useMemo(analysisSelector, []);
  const analysis = useAppSelector((state) =>
    analysisMemoizedSelector(state, analysisId),
  );
  const handleClose = () => {
    dispatch(closeModal());
  };

  const { loading, createDeleteContentHandler } =
    useDashboardDeleteContent(dashboard);

  const handleSubmit = async () => {
    const deleteContentHandler = createDeleteContentHandler(position);
    await deleteContentHandler();
    handleClose();
  };

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={handleSubmit}
      header={'Delete Confirmation'}
      confirmActionLabel={'Delete'}
      disabled={loading}
      trackContext="dashboards"
      trackConfirmAction="delete report - delete"
      trackCancelAction="delete report - cancel"
    >
      Do you want to delete <strong>{analysis?.metadata?.display ?? ''}</strong>{' '}
      from <strong>{dashboard.name}</strong>? This action cannot be undone.
    </ConfirmationModal>
  );
};

export default DashboardDeleteReportModal;
